const dayFormatter = new Intl.DateTimeFormat('fr-FR', { day: 'numeric', month: 'short' });
const timeFormatter = new Intl.DateTimeFormat('fr-FR', { hour: '2-digit', minute: '2-digit' });

/** "23 oct. · 17:24". */
const formatShortDateTime = (instant: Date): string => {
	return `${dayFormatter.format(instant)} · ${timeFormatter.format(instant)}`;
};

export default formatShortDateTime;
